var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 0.916667C11.6025 0.7125 10.8908 0.625 10.2083 0.625C9.07081 0.625 7.84581 0.858333 6.99998 1.5C6.15415 0.858333 4.92915 0.625 3.79165 0.625C2.65415 0.625 1.42915 0.858333 0.583313 1.5V10.0458C0.583313 10.1917 0.729146 10.3375 0.87498 10.3375C0.933313 10.3375 0.96248 10.3083 1.02081 10.3083C1.80831 9.92917 2.94581 9.66667 3.79165 9.66667C4.92915 9.66667 6.15415 9.9 6.99998 10.5417C7.78748 10.0458 9.21665 9.66667 10.2083 9.66667C11.1708 9.66667 12.1625 9.84167 12.9791 10.2792C13.0375 10.3083 13.0666 10.3083 13.125 10.3083C13.2708 10.3083 13.4166 10.1625 13.4166 10.0167V1.5C13.0666 1.2375 12.6875 1.0625 12.25 0.916667ZM12.25 8.79167C11.6083 8.5875 10.9083 8.5 10.2083 8.5C9.21665 8.5 7.78748 8.87917 6.99998 9.375V2.66667C7.78748 2.17083 9.21665 1.79167 10.2083 1.79167C10.9083 1.79167 11.6083 1.87917 12.25 2.08333V8.79167Z",
    fill: "#1F8598"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.02105074129edcb6867b7d47102a563e.svg";
export { ForwardRef as ReactComponent };